/**
 * Shared state для дропдаун-меню в мобильных карточках таблицы.
 *
 * Проблема: каждая карточка — отдельный экземпляр компонента в v-for.
 *          UDropdownMenu по умолчанию не знает о других карточках,
 *          поэтому при открытии меню на одной карточке остальные не закрываются.
 *
 * Решение: модульный ref activeMenuId общий для всех карточек.
 *          При открытии записываем id карточки, при закрытии или клике
 *          вне меню — сбрасываем в null.
 *          Глобальный обработчик click на document ловит клики вне меню.
 *
 * Флаг ignoreNextClick: тот же клик, который открыл меню, не должен его закрыть.
 */

import { ref, computed } from 'vue'

const activeMenuId = ref(null)
let ignoreNextClick = false

if (typeof document !== 'undefined') {
  document.addEventListener('click', () => {
    if (ignoreNextClick) {
      ignoreNextClick = false
      return
    }
    activeMenuId.value = null
  })
}

/**
 * @param {import('vue').ComputedRef<string|number|null>} menuId — уникальный id карточки
 * @returns {{ isMenuOpen: import('vue').WritableComputedRef<boolean> }}
 */
export function useTableCardMenu(menuId) {
  const isMenuOpen = computed({
    get: () => activeMenuId.value === menuId.value,
    set: (val) => {
      if (val) {
        activeMenuId.value = menuId.value
        ignoreNextClick = true
      } else {
        activeMenuId.value = null
      }
    },
  })

  return { isMenuOpen }
}
